export const SYSTEM_VARIABLE_OPTIONS = [
  { label: 'Session ID', value: 'session_id' },
  { label: 'User ID', value: 'user_id' },
  { label: 'Email ID', value: 'email_id' },
] as const;

export type SystemVariableValue = (typeof SYSTEM_VARIABLE_OPTIONS)[number]['value'];

export const isSystemVariable = (type: string | undefined): boolean => {
  return type === 'variable';
};

export const getSystemVariableLabel = (value: string): string | undefined => {
  return SYSTEM_VARIABLE_OPTIONS.find((opt) => opt.value === value)?.label;
};
